import { Injectable } from '@angular/core';
import { ES } from './es.service';
import { API } from './api.service';
import { AuthService } from './auth-service';
import * as _ from 'lodash';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class SearchService {
    private lastSearchRoute: string = '';
    public lastSavedSearchId = 0;
    public lastResultCount = 0;

    constructor(private es: ES, private api: API, private authService: AuthService) {

    }

    getSearchResults(queryString: string, searchCriteria: BasicSearchParams, pageParams: any = false) {
        let options = this.es.getBasicSearchCriteria(queryString, searchCriteria, pageParams);
        return this.es.listing(options).then((body) => {
            if (body) {
                if (body.hits.hits && body.hits.total) {
                    let hits = body.hits.hits;
                    let total = body.hits.total;
                    return { data: _.groupBy(hits, '_type'), total: total };
                }
            }
        });
    }

    loadAdvancedSearchData() {
        return Observable.forkJoin(
            this.loadGeneres(),
            this.loadDecades(),
            this.loadInstruments(),
            this.loadTempos(),
            this.loadVocals()
        );
    }

    loadGeneres() {
        return this.api.get('songs/genres');
    }

    loadInstruments() {
        return this.api.get('songs/instruments');
    }

    loadTempos() {
        return this.api.get('songs/tempos');
    }

    loadDecades() {
        return this.api.get('songs/decades');
    }

    loadVocals() {
        return this.api.get('songs/vocals');
    }

    saveSearchPreference(searchParams) {
        let prefs = new Array<any>();
        prefs.push({ key: 'searchArtists', value: searchParams.searchArtists });
        prefs.push({ key: 'searchCollections', value: searchParams.searchCollections });
        prefs.push({ key: 'searchPlaylists', value: searchParams.searchPlaylists });
        prefs.push({ key: 'searchSongs', value: searchParams.searchSongs });
        prefs.push({ key: 'searchUsers', value: searchParams.searchUsers });

        localStorage.setItem('searchPreferences', JSON.stringify(prefs));
        if (this.authService.isUserLoggedIn()) {
            return this.api.post('user/save-preferences', prefs);
        } else {
            return Observable.create((res) => {
                return [];
            });
        }
    }

    saveSearchQuery(searchParams: BasicSearchParams) {
        let request = {
            query: searchParams.query,
            search_songs: + searchParams.searchSongs,
            search_collections: +searchParams.searchCollections,
            search_artists: +searchParams.searchArtists,
            search_playlists: +searchParams.searchPlaylists,
            search_users: +searchParams.searchUsers
        };
        return this.api.post('user/save-search', request).map((res) => {
            this.lastSavedSearchId = res.id;
            return res;
        });
    }

    getSearchPreferences() {
        return this.api.get('user/get-preferences').map((res) => {
            res.forEach((arrayItem) => {
                if (arrayItem.value === '1') {
                    arrayItem.value = true;
                }
                if (arrayItem.value === '') {
                    arrayItem.value = false;
                }
            });
            return res;
        });
    }

    setLastSearch(query: string) {
        this.lastSearchRoute = query;
    }

    getLastSearch() {
        return this.lastSearchRoute;
    }

    fetchIds(hits) {
        let ids = new Array<any>();
        hits.forEach((arrayItem) => {
            ids.push(arrayItem._id);
        });
        return ids;

    }
}

export class BasicSearchParams {
    public query: string = '';
    public searchSongs: boolean = true;
    public searchCollections: boolean = false;
    public searchArtists: boolean = true;
    public searchPlaylists: boolean = false;
    public searchUsers: boolean = false;
    public searchLike: boolean = false;
    public searchCredits: boolean = false;
    public totalResults: number = 0;

    constructor(song = true, collection = false, artist = true, playlist = false, users = false, like = false, credits = false) {
        this.searchSongs = song;
        this.searchCollections = collection;
        this.searchPlaylists = playlist;
        this.searchArtists = artist;
        this.searchUsers = users;
        this.searchLike = like;
        this.searchCredits = credits;
    }

    processPreferences() {
        // if (!!localStorage.getItem('searchPreferences')) {
        //     let prefs = JSON.parse(localStorage.getItem('searchPreferences'));
        //     prefs.forEach((arrayItem) => {
        //         if (arrayItem.key === 'searchSongs') {
        //             this.searchSongs = arrayItem.value;
        //         }
        //         if (arrayItem.key === 'searchCollections') {
        //             this.searchCollections = arrayItem.value;
        //         }
        //         if (arrayItem.key === 'searchArtists') {
        //             this.searchArtists = arrayItem.value;
        //         }
        //         if (arrayItem.key === 'searchPlaylists') {
        //             this.searchPlaylists = arrayItem.value;
        //         }
        //         if (arrayItem.key === 'searchUsers') {
        //             this.searchUsers = arrayItem.value;
        //         }
        //     });
        // } else 
        // {
        //     this.searchSongs = true;
        //     this.searchCollections = false;
        //     this.searchArtists = true;
        //     this.searchPlaylists = false;
        //     this.searchUsers = false;
        // }
    }
}

export class AdvancedSearchParams {
    public selectedGenre: number = 0;
    public selectedDecades: number = 0;
    public selectedInstruments: number = 0;
    public selectedTempos: number = 0;
    public selectedVocals: number = 0;
    public minLength: number = 0;
    public maxLength: number = 0;
}



// WEBPACK FOOTER //
// ./src/app/api/services/search.service.ts